import { createRoot } from 'react-dom/client';
import './index.css';
import AppContainer from './AppContainer';
import * as serviceWorker from './serviceWorker';

createRoot(document.getElementById('root')).render(<AppContainer />);

serviceWorker.unregister();
